/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getNeighborhoodsVisibilityPauseStatus} from '../api'

 export const useQueryGetNeighborhoodsVisibilityPauseStatus = createReactQueryHook('getNeighborhoodsVisibilityPauseStatus', getNeighborhoodsVisibilityPauseStatus)
